import * as React from 'react'
import {ReactElement} from 'react'
import {NatApplicationRepo} from '../repository/NatApplicationRepo'
import {Nullable} from '../../../../app/TypeHelpers'
import {BlockSpacer} from '../../../../styledComponents/ResponsiveConvenience'
import {DisplayItemDividerForPageTop} from '../../../../styledComponents/DisplayItem'
import {
    CenterPlainLinkStyledButton,
    PlainLinkStyledBackButton,
    PrimaryStyledButton,
} from '../../../../styledComponents/Button'
import {Box} from '@mui/material'
import {PageTitle} from '../common/resident/NatResidentApplicationsCommon'
import {
    createResidentWithErrorHandlingPage,
    ResidentWithErrorHandlingPagePropsSet,
} from '../../../../components/shared/hoc/createResidentWithErrorHandlingPage'
import NatCurrentDateTimeRepo from '../../currentDateTime/repository/NatCurrentDateTimeRepo'
import NatResidentHeavyLoadsCarryConfirm from './resident/NatResidentHeavyLoadsCarryConfirm'
import {
    NatResidentHeavyLoadsCarryInfo,
    NatResidentHeavyLoadsCarryLocationState,
} from './NatResidentApplicationInterface'
import {NatPutHeavyLoadsCarryRequest, NatPutHeavyLoadsCarryResponse} from '../repository/NatPutHeavyLoadsCarry'
import {Location} from 'react-router-dom'

interface Props {
    condominiumCd: string
    applicationRepo: NatApplicationRepo
    currentDateTimeRepo: NatCurrentDateTimeRepo
    location: Location<NatResidentHeavyLoadsCarryLocationState>
}

class NatResidentHeavyLoadsCarryConfirmPage
    extends React.Component<Props & ResidentWithErrorHandlingPagePropsSet> {

    constructor(props: Props & ResidentWithErrorHandlingPagePropsSet) {
        super(props)

        this.handleRegisterButtonClick = this.handleRegisterButtonClick.bind(this)
        this.handleBackLinkOnClick = this.handleBackLinkOnClick.bind(this)
    }

    async handleRegisterButtonClick(): Promise<void> {
        await this.props.eventEmitter.showLoading()
        const {applicationRepo, condominiumCd} = this.props
        const locationState: NatResidentHeavyLoadsCarryInfo = this.props.location.state.applyInfo
        const {
            applicantFamilyName,
            applicantFirstName,
            heavyWeightGoodsDetail,
            carryingStartDate,
            carryingEndDate,
            applyToAttachment,
        } = locationState

        const copyFileNumbers: number[] = applyToAttachment
            .map(attachment => attachment.fileNumber)
            .filter((fileNumber): fileNumber is Exclude<typeof fileNumber, undefined> => fileNumber !== undefined)
            .filter((fileNumber): fileNumber is Exclude<typeof fileNumber, null> => fileNumber !== null)

        const request: NatPutHeavyLoadsCarryRequest = {
            applicantFamilyName: applicantFamilyName,
            applicantFirstName: applicantFirstName,
            heavyWeightGoodsDetail: heavyWeightGoodsDetail,
            carryingStartDate: carryingStartDate,
            carryingEndDate: carryingEndDate,
            reApplyCopyFileNumbers: copyFileNumbers,
            confirmed: true,
        }

        if (!request) {
            return
        }

        try {
            const response: Nullable<NatPutHeavyLoadsCarryResponse> = await this.props.asyncCallFunction(
                applicationRepo.applyHeavyLoadsCarry.bind(
                    applicationRepo, condominiumCd, request),
                () => {
                    this.props.navigate(`/resident/error`, {replace: true})
                },
            )
            if (response && response.requestError === null) {
                this.props.navigate(
                    `/resident/condominiums/${this.props.condominiumCd}/applications/complete`,
                    {replace: true},
                )
            }
        } finally {
            this.props.eventEmitter.closeLoading()
        }
    }

    handleBackLinkOnClick(): void {
        const locationState: NatResidentHeavyLoadsCarryLocationState = this.props.location.state
        this.props.navigate(
            `/resident/condominiums/${this.props.condominiumCd}/applications/heavyLoadsCarries/input`,
            {
                replace: true,
                state: JSON.parse(JSON.stringify(locationState)),
            },
        )
    }

    render(): ReactElement {
        return (
            <>
                <PlainLinkStyledBackButton onClick={this.handleBackLinkOnClick}>戻る</PlainLinkStyledBackButton>
                <BlockSpacer height={'16px'}/>
                <DisplayItemDividerForPageTop/>
                <BlockSpacer height={'30px'}/>
                <PageTitle>
                    申請内容確認
                </PageTitle>
                <Box height={'20px'}/>
                <NatResidentHeavyLoadsCarryConfirm
                    {...this.props.location.state.applyInfo}
                />
                <BlockSpacer height={'30px'}/>
                <PrimaryStyledButton onClick={this.handleRegisterButtonClick}>
                    申請を提出する
                </PrimaryStyledButton>
                <BlockSpacer height={'20px'}/>
                <CenterPlainLinkStyledButton onClick={this.handleBackLinkOnClick}>
                    修正する
                </CenterPlainLinkStyledButton>
                <BlockSpacer height={'15px'}/>
            </>
        )
    }
}

export default createResidentWithErrorHandlingPage(NatResidentHeavyLoadsCarryConfirmPage)
